import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

// components
import AppCard from 'src/components/AppCard'
import AppCardHeader from 'src/components/card/AppCardHeader'
import AppDetails from 'src/components/details/product-details/AppDetails'

// helpers
import Axios from 'src/helpers/axios'

const ProductDetails = () => {
  const navigate = useNavigate()
  const params = useParams()
  const { id } = params

  const [productDetails, setProductDetails] = useState('')

  const handleCardHeaderButton = () => {
    navigate(`/products/edit/${id}`)
    window.location.reload();
  }

  useEffect(() => {
    fetchProductDetails()
  }, [id]);

  const fetchProductDetails = () => {
    Axios({
      method: "get",
      url: `/api/ecommerce/v1/products/id/${id}`,
    })
      .then(({ data }) => {
        setProductDetails(data)
      })
      .catch((err) => {
        console.error(err);
      });
  }

  return (
    <AppCard
      className='mt-4 mb-4'
      headerTitle={
        <AppCardHeader
          headerTitle={<h4>Voucher Details</h4>}
          headerButton="Edit"
          handleCardHeaderButton={handleCardHeaderButton}
        />
      }
      bodyContent={
        <AppDetails
          productDetails={productDetails}
        />
      }
    />
  )
}

export default ProductDetails
